import React from 'react'

class EditProfile extends React.Component {
	constructor(props) {
		super(props)
		this.ref = React.createRef()
	}

	componentDidMount() {
		this.componentDidUpdate()
	}

	componentDidUpdate() {
		const {mat, onSuccess} = this.props
		const el = $(this.ref.current)

		el.load(`/users/edit/${mat.user_id}.ajax?fromLeadership=${mat.fromLeadership}`, () => {
			const form = el.find('form')
			form.attr('action', form.attr("action").replace(/\.ajax/, '.json') + "?action=submit_all&ignore_session=1")
			hp.utils.setup(el, {
				after: response => {
					if (response.ok) {
						mbox.dismiss();
						onSuccess({nif: response.nif, doc_id: response.doc_id});
					}
				}
			});
		})
	}

	render() {
		return (
			<div ref={this.ref} />
		)
	}
}

export default (mat, onSuccess) => {
	mbox.modal(<EditProfile mat={mat} onSuccess={onSuccess} />, {
		title: mat.name,
		buttons: [
			{
				text: __('buttons_save'),
				type: 'primary',
				icon: 'check',
				onClick: () => {
					$('form').submit();
				}
			},
			'cancel'
		]
	})
}

